import cn from 'clsx'

import { Tooltip, IconVerified } from '@tracklib/kit'
import styles from './userbadges.css'

const renderIcon = (group: string) => {
  if (group === 'verified') {
    return <IconVerified className={styles.verified} />
  }
  if (group === 'betauser' || group === 'beta') {
    return <span className={styles.beta}>Beta</span>
  }
  return null
}

const renderTooltip = (group: string) => {
  if (group === 'verified') {
    return 'Verified user'
  }
  if (group === 'betauser' || group === 'beta') {
    return 'Beta user'
  }
  return null
}

type VerifiedBadgeProps = {
  groups: Array<string>
  showTooltip?: boolean
  size?: string
}

const UserBadges = ({ groups, showTooltip = true, size = 'small' }: VerifiedBadgeProps): JSX.Element | null => {
  if (groups && groups.length && groups.some(x => x === 'verified' || x === 'betauser' || x === 'beta')) {
    return (
      <ul className={cn(styles.wrapper, size === 'small' && styles.small)}>
        {groups.map(group => {
          if (renderIcon(group)) {
            return (
              <li className={styles.badge} data-tooltip-wrapper key={group}>
                {showTooltip && <Tooltip>{renderTooltip(group)}</Tooltip>}
                {renderIcon(group)}
              </li>
            )
          }
          return null
        })}
      </ul>
    )
  }
  return null
}

export default UserBadges
